import React from 'react';
import Slider from 'react-slick';


const Testimonial = () => {
    const settings = {
        infinite: true,
        speed: 500,
        //   slidesToShow: 1,
        //   slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: false
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true
                }
            }
        ]
    };

    // useEffect(() => {
    //     $(window).resize(function () {
    //         $(".testimonial_slick")[0].slick.refresh();
    //     });
    // }, []);

    return (
        <div className="container">
            <div className="testimonial">
                <h2 className="testimonial_heading">You said about us</h2>

                <Slider {...settings}>
                    <div>
                        <div className="testibox1">
                            <div className="testibox_inner">
                                <div className="testi-top">
                                    <div className="testi-img">
                                        <img src="images/reviewer1.png" alt="" />
                                    </div>
                                    <ul className="rating">
                                        <li><i className="ion-ios-star"></i></li>
                                        <li><i className="ion-ios-star"></i></li>
                                        <li><i className="ion-ios-star"></i></li>
                                        <li><i className="ion-ios-star"></i></li>
                                        <li><i className="ion-ios-star-half"></i></li>
                                    </ul>
                                </div>
                                <div className="testi-content">
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing
                                        elit, iusmod tempor incididu a aliqua. Ut enim ad
                                        minim veniam, quis nostrud exercitation
                                    </p>

                                    <div className="testi_info">
                                        <h5>Anjelina Gomej</h5>
                                        <h6>New York</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div className="testibox1">
                            <div className="testibox_inner">
                                <div className="testi-top">
                                    <div className="testi-img">
                                        <img src="images/reviewer1.png" alt="" />
                                    </div>
                                    <ul className="rating">
                                        <li><i className="ion-ios-star"></i></li>
                                        <li><i className="ion-ios-star"></i></li>
                                        <li><i className="ion-ios-star"></i></li>
                                        <li><i className="ion-ios-star"></i></li>
                                        <li><i className="ion-ios-star-half"></i></li>
                                    </ul>
                                </div>
                                <div className="testi-content">
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing
                                        elit, iusmod tempor incididu a aliqua. Ut enim ad
                                        minim veniam, quis nostrud exercitation
                                    </p>

                                    <div className="testi_info">
                                        <h5>Anjelina Gomej</h5>
                                        <h6>New York</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="testibox1">
                            <div className="testibox_inner">
                                <div className="testi-top">
                                    <div className="testi-img">
                                        <img src="images/reviewer1.png" alt="" />
                                    </div>
                                    <ul className="rating">
                                        <li><i className="ion-ios-star"></i></li>
                                        <li><i className="ion-ios-star"></i></li>
                                        <li><i className="ion-ios-star"></i></li>
                                        <li><i className="ion-ios-star"></i></li>
                                        <li><i className="ion-ios-star-half"></i></li>
                                    </ul>
                                </div>
                                <div className="testi-content">
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing
                                        elit, iusmod tempor incididu a aliqua. Ut enim ad
                                        minim veniam, quis nostrud exercitation
                                    </p>

                                    <div className="testi_info">
                                        <h5>Anjelina Gomej</h5>
                                        <h6>New York</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </Slider>

            </div>
        </div>

    );
};

export default Testimonial;